{
  "common.app.name": "Helsinki Airport drop-off",

  "common.yes": "yes",
  "common.no": "no",
  "common.ok": "ok",
  "common.NA": "N/A",

  "common.system.enabledTitle": "System is enabled",
  "common.system.enabledDescription": "Parking fees are charged according to time and tariff.",
  "common.system.enableButtonText": "Enable",
  "common.system.disabledTitle": "System is disabled",
  "common.system.disabledDescription": "All parking is free of charge.",
  "common.system.disabledReason": "Reason: {reason}",
  "common.system.disableButtonText": "Disable",
  "common.system.statusCheckErrorToastText": "System status check failed.",
  "common.system.unknownTitle": "System status is unknown",
  "common.system.unknownDescription": "Error retrieving status information. Try again later.",
  "common.system.changeStatusModal.title.enable": "Enable system",
  "common.system.changeStatusForm.title.enable": "Provide reason for enabling the system",
  "common.system.changeStatusForm.submit.enable": "Enable",
  "common.system.changeStatusForm.success.enable": "System is now enabled.",
  "common.system.changeStatusForm.submit.disable": "Disable",
  "common.system.changeStatusModal.title.disable": "Disable system",
  "common.system.changeStatusForm.title.disable": "Provide reason for disabling the system",
  "common.system.changeStatusForm.success.disable": "System is now disabled.",
  "common.system.changeStatusForm.label.reason": "Reason",

  "common.text.duration": "Duration",
  "common.text.email": "Email",
  "common.text.endTime": "End time",
  "common.text.entryLane": "Entry lane",
  "common.text.exempt": "Exempt from fee",
  "common.text.exemptVehicles": "Exempt vehicles",
  "common.text.exitLane": "Exit lane",
  "common.text.hasEnded": "Ended",
  "common.text.licensePlate": "Registration number",
  "common.text.parkingEvents": "Parking events",
  "common.text.paymentStatus": "Payment status",
  "common.text.price": "Price",
  "common.text.site": "Site",
  "common.text.startTime": "Start time",
  "common.text.timestamp": "Timestamp",
  "common.text.whitelist": "Exempt vehicles",

  "common.units.hours.short": "h",
  "common.units.minutes.short": "m",
  "common.units.seconds.short": "s",

  "common.buttons.yes": "Yes",
  "common.buttons.add": "Add",
  "common.buttons.save": "Save",
  "common.buttons.edit": "Edit",
  "common.buttons.next": "Next",
  "common.buttons.complete": "Complete",
  "common.buttons.cancel": "Cancel",
  "common.buttons.remove": "Remove",
  "common.buttons.update": "Update",
  "common.buttons.terminate": "Terminate",
  "common.buttons.back": "Back",

  "common.actions.error": "An error occurred",
  "common.actions.add.error": "Adding failed",
  "common.actions.update.error": "Updating failed",
  "common.actions.get.error": "Failed to get data",
  "common.actions.remove.error": "Failed to remove data",
  "common.actions.search": "Search",

  "common.form.errors.empty": "The field cannot be empty.",
  "common.form.errors.licensePlate": "Enter a valid vehicle's registration number.",
  "common.form.errors.number": "Only numbers can be entered in the field.",
  "common.form.errors.centsOnly": "Please round to nearest cent.",
  "common.form.errors.negative": "The value cannot be negative.",

  "common.access.readOnly": "Read only access",

  "common.paymentStatus.free": "Free",
  "common.paymentStatus.unpaid": "Unpaid",
  "common.paymentStatus.paid": "Paid",
  "common.paymentStatus.invoicing": "Post invoicing",
  "common.paymentStatus.timedOut": "Timed out",
  "common.paymentStatus.undefined": "Not yet assigned",
  "common.paymentStatus.unknown": "Unknown",

  "dateTimeRangePicker.labels.start": "Start",
  "dateTimeRangePicker.labels.end": "End",

  "components.selectSearchField.selectedCountText": "{count} selected",

  "page.userDetails.title": "User details",
  "page.userDetails.userFullName": "Name",
  "page.userDetails.role": "Role",

  "page.site.status": "System status",
  "page.site.status.description": "The system can be disabled in case of disruptions.",

  "page.parkingEvents.ongoing": "Ongoing",
  "page.parkingEvents.ended": "Ended",
  "page.parkingEvents.ongoing.emptyText": "No ongoing parking events found with the selected filters.",
  "page.parkingEvents.ended.emptyText": "No ended parking events found with the selected filters.",

  "page.parkingDetails.title": "Parking event details",
  "page.parkingDetails.summary": "Summary",
  "page.parkingDetails.summary.editButton": "Invalidate fee",
  "page.parkingDetails.entryCamera": "Entry",
  "page.parkingDetails.exitCamera": "Exit",
  "page.parkingDetails.noCamera": "Camera not available",
  "page.parkingDetails.id": "Parking event ID",
  "page.parkingDetails.editFee": "Invalidate fee",
  "page.parkingDetails.camera.name": "Camera name",
  "page.parkingDetails.camera.id": "Camera ID",
  "page.parkingDetails.camera.photo": "Photo",
  "page.parkingDetails.camera.lane": "Lane",
  "page.parkingDetails.camera.imageMissing": "image not available",
  "page.parkingDetails.modalEditFee.title": "Invalidate fee",
  "page.parkingDetails.formEditFee.label.comment": "Reason for fee invalidation",
  "page.parkingDetails.formEditFee.label.price": "Price (€)",
  "page.parkingDetails.formEditFee.label.pricePreview": "Amount after fee invalidation",
  "page.parkingDetails.formEditFee.submit": "Invalidate",
  "page.parkingDetails.editFee.success": "Parking fee update request has been sent.",
  "page.parkingDetails.editFee.genericError": "Failed to send parking fee update request.",

  "page.whitelist.description": "View vehicles that are exempt from parking fees.",
  "page.whitelist.description.create": "You can also add, edit and remove vehicles.",
  "page.whitelist.description.readOnly": "You do not have permission to edit the list.",
  "page.whitelist.table.emptyText": "No exempt vehicles found with the selected filters.",
  "page.whitelist.table.header.name": "Name",
  "page.whitelist.table.header.createdAt": "Created at",
  "page.whitelist.form.label.name": "Name",
  "page.whitelist.form.label.comment": "Reason for change",
  "page.whitelist.modal.edit.title": "Edit exempt vehicle",
  "page.whitelist.modal.view.title": "View exempt vehicle",
  "page.whitelist.modal.create.title": "Add an exempt vehicle",
  "page.whitelist.form.edit.title": "Edit the name of the exempt vehicle or remove it. A reason for the change is required in both cases.",
  "page.whitelist.form.view.title": "View exempt vehicle details (read-only).",
  "page.whitelist.form.create.title": "Create a new exempt vehicle.",
  "page.whitelist.modal.edit.button.submit": "Update",
  "page.whitelist.modal.view.button.submit": "Close",
  "page.whitelist.modal.create.button.submit": "Create",
  "page.whitelist.modal.delete.success": "Exempt vehicle {plate} has been removed.",
  "page.whitelist.modal.delete.error": "Failed to remove exempt vehicle",
  "page.whitelist.modal.edit.success": "Exempt vehicle {plate} has been updated.",
  "page.whitelist.modal.edit.error": "Failed to update exempt vehicle.",
  "page.whitelist.modal.create.success": "Exempt vehicle has been added.",
  "page.whitelist.modal.create.error": "Failed to add exempt vehicle.",

  "sortControl.sortingCriteria": "Sort by",

  "sortDirection.ASC": "Ascending",
  "sortDirection.DESC": "Descending",

  "sort.WHITELIST.NAME": "Name",
  "sort.WHITELIST.LICENSE_PLATE": "Registration number",
  "sort.WHITELIST.CREATED_AT": "Created at",

  "sort.PARKING_EVENTS_ENDED.LICENSE_PLATE": "Registration number",
  "sort.PARKING_EVENTS_ENDED.START": "Start time",
  "sort.PARKING_EVENTS_ENDED.END": "End time",
  "sort.PARKING_EVENTS_ENDED.DURATION": "Duration",
  "sort.PARKING_EVENTS_ENDED.PRICE": "Price",
  "sort.PARKING_EVENTS_ENDED.PAYMENT": "Payment status",

  "sort.PARKING_EVENTS_ONGOING.LICENSE_PLATE": "Registration number",
  "sort.PARKING_EVENTS_ONGOING.ENTRY_LANE": "Entry lane",
  "sort.PARKING_EVENTS_ONGOING.START": "Start time",
  "sort.PARKING_EVENTS_ONGOING.DURATION": "Duration",

  "menu.user.detail": "Own details",
  "menu.user.logout": "Sign out",
  "menu.user.fi": "Suomeksi",
  "menu.user.en": "In English",
  "menu.user.tooltip.admin": "Admin user",
  "menu.user.tooltip.user": "Regular user",

  "appMenu.subtitle": "Parking management",
  "appMenuTop.button.menu": "Menu",
  "appMenuTop.button.closeMenu": "Close menu",

  "moovyErrorPage.oops": "Oops!",
  "moovyErrorPage.message": "Sorry, an unexpected error has occurred. Please, check the url and try to refresh the view again.",

  "login.title": "Sign in",
  "login.button.azure": "Microsoft Entra",
  "login.toast.error": "An error occurred while logging in.",
  "logout.toast.error": "An error occurred while logging out.",
  "authentication.error.configuration": "The application's authentication system is not properly configured and logging in is not possible.",

  "timestampItems.createdAt": "Created at",
  "timestampItems.updatedAt": "Updated at"
}
